/* unplugin-vue-components disabled */import { ElForm as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElButton as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElSelect as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue";
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiUsdkCpsDistributeChannelList, apiUsdkCpsDistributeForbid } from '@/api/usdk';
import DistributeForm from './distributeForm.vue';
import { useTaskStore } from '@/store/modules/downTask';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const {
      setTask
    } = useTaskStore();
    const distributeFormRef = ref();
    const filter = ref({
      name: '',
      cooperate_type: '',
      cooperate_status: ''
    });
    // 合作方式数据集
    const cooperWayList = [{
      key: '',
      val: '全部'
    }, {
      key: 1,
      val: '分成'
    }, {
      key: 2,
      val: '导量'
    }];
    // 合作状态数据集
    const cooperStatusList = [{
      key: '',
      val: '全部'
    }, {
      key: 1,
      val: '合作中'
    }, {
      key: 0,
      val: '已终止'
    }];
    const columns = [{
      label: '渠道ID',
      prop: 'id'
    }, {
      label: '渠道名称',
      prop: 'name'
    }, {
      label: '渠道公司名称',
      prop: 'companyName'
    }, {
      label: '分类归属',
      prop: 'parentChannel'
    }, {
      label: '合作状态',
      prop: 'statusInfo'
    }, {
      label: '合作方式',
      prop: 'cooperateInfo'
    }, {
      label: '分成比',
      prop: 'divided'
    }, {
      label: '创建人及时间',
      prop: 'createTime',
      slot: 'personTime'
    }, {
      label: '操作',
      action: true
    }];
    const getTableData = () => {
      tableLoading.value = true;
      const {
        cooperate_status,
        cooperate_type,
        name
      } = filter.value;
      const params = {
        status: cooperate_status,
        name,
        cooperateType: cooperate_type,
        pageNumber: current.value,
        pageSize: pageSize.value
      };
      apiUsdkCpsDistributeChannelList(params).then(res => {
        if (res.code === 0) {
          tableData.value = res.data.list || [];
          total.value = res.data.totalRow;
        }
      }).finally(() => {
        tableLoading.value = false;
      });
    };
    const handleClick = (type, data) => {
      // 新增 or 编辑
      if (type === 'add' || type === 'edit') {
        distributeFormRef.value.show(data);
      } else if (type === 'status') {
        // 修改状态
        apiUsdkCpsDistributeForbid({
          id: data.id,
          status: data.status ? 0 : 1
        }).then(res => {
          if (res.code === 0) {
            getTableData();
          }
        });
      }
    };
    const {
      tableData,
      tableLoading,
      total,
      pageSize,
      current,
      handleSizeChange,
      handleCurrentChange
    } = UseTable(getTableData);
    const exportData = () => {
      const {
        cooperate_status,
        cooperate_type,
        name
      } = filter.value;
      const params = {
        status: cooperate_status,
        name,
        cooperateType: cooperate_type
      };
      setTask({
        api: apiUsdkCpsDistributeChannelList,
        page: 'pageNumber',
        pageSize: 'pageSize',
        params,
        data: 'data.list',
        total: 'data.totalRow',
        excel: {
          title: '分发渠道列表',
          header: ['渠道ID', '渠道名称', '渠道公司名称', '分类归属', '合作状态', '合作方式', '分成比', '创建人', '创建时间'],
          field: ['id', 'name', 'companyName', 'parentChannel', 'statusInfo', 'cooperateInfo', 'divided', 'createUser', 'createTime']
        }
      });
    };
    onMounted(() => {
      getTableData();
    });
    return (_ctx, _cache) => {
      const _component_el_input = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_option = __unplugin_components_2;
      const _component_el_select = __unplugin_components_3;
      const _component_el_button = __unplugin_components_4;
      const _component_el_form = __unplugin_components_5;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_form, {
        inline: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "渠道名称"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(filter).name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(filter).name = $event),
            class: "marginR10",
            placeholder: "渠道名称"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "合作方式"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(filter).cooperate_type,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(filter).cooperate_type = $event),
            class: "marginR10",
            placeholder: "请选择合作方式",
            allowClear: "",
            onChange: getTableData
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(cooperWayList, item => {
              return _createVNode(_component_el_option, {
                value: item.key,
                key: item.key,
                label: item.val
              }, null, 8, ["value", "label"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "合作状态"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(filter).cooperate_status,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(filter).cooperate_status = $event),
            placeholder: "请选择合作状态",
            allowClear: "",
            onChange: getTableData
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(cooperStatusList, item => {
              return _createVNode(_component_el_option, {
                value: item.key,
                key: item.key,
                label: item.val
              }, null, 8, ["value", "label"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: getTableData
          }, {
            default: _withCtx(() => [_createTextVNode("搜索")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_form, {
        inline: "",
        class: "marginB10 text-right"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = $event => handleClick('add')),
            class: "marginR10",
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("新建渠道")]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: exportData
          }, {
            default: _withCtx(() => [_createTextVNode("导出列表")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(UTable, {
        options: columns,
        "row-key": "cid",
        pagination: "",
        data: _unref(tableData),
        loading: _unref(tableLoading),
        "current-page": _unref(current),
        "page-size": _unref(pageSize),
        total: _unref(total),
        onSizeChange: _unref(handleSizeChange),
        onCurrentChange: _unref(handleCurrentChange)
      }, {
        personTime: _withCtx(({
          scope
        }) => [_createTextVNode(_toDisplayString(scope.row.createUser) + "/" + _toDisplayString(scope.row.createTime), 1)]),
        action: _withCtx(({
          scope
        }) => [_createVNode(_component_el_button, {
          link: "",
          type: "primary",
          onClick: $event => handleClick('edit', scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode("编辑")]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          link: "",
          type: scope.row.status === 0 ? 'primary' : 'danger',
          onClick: $event => handleClick('status', scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.status === 0 ? '启用' : '禁用'), 1)]),
          _: 2
        }, 1032, ["type", "onClick"])]),
        _: 1
      }, 8, ["data", "loading", "current-page", "page-size", "total", "onSizeChange", "onCurrentChange"]), _createVNode(DistributeForm, {
        ref_key: "distributeFormRef",
        ref: distributeFormRef,
        onSuccess: getTableData
      }, null, 512)], 64);
    };
  }
});